import {
  CrmFieldService,
  StandardIds,
} from '@galaxy/crm/services/field-service';
import {
  BehaviorSubject,
  catchError,
  Observable,
  of,
} from 'rxjs';
import {
  CrmObjectInterface,
  ListCrmObjectsRequestInterface,
  ListCrmObjectsResponseInterface,
} from '@vendasta/crm';
import {
  map,
  switchMap,
} from 'rxjs/operators';
import {
  CrmInjectionToken,
  CrmDependencies,
} from '../tokens-and-interfaces';
import { CrmObjectService } from './crm-services/crm-object-service/crm-object.service';
import {
  Inject,
  Injectable,
} from '@angular/core';

export interface CompanyDisplayName extends CrmObjectInterface {
  displayName: string;
}

@Injectable({
  providedIn: 'root',
})
export class CompanyFiltersService {
  searchTerm$$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(
    private crmObjectService: CrmObjectService,
    private crmFieldService: CrmFieldService,
    @Inject(CrmInjectionToken) private readonly crmConfig: CrmDependencies,
  ) {}

  private listObjects(
    namespace: string,
    cursor: string,
    pageSize: number,
    search: string,
  ): Observable<ListCrmObjectsResponseInterface> {
    const request: ListCrmObjectsRequestInterface = {
      namespace: namespace,
      pagingOptions: {
        cursor: cursor,
        pageSize: pageSize,
      },
      search: {
        searchTerm: search,
      },
    };
    return this.crmObjectService.listObjects('Company', request);
  }

  listReadableCompanies(searchTerm: string): Observable<CompanyDisplayName[]> {
    return this.crmConfig.namespace$.pipe(
      switchMap((namespace) => this.listObjects(namespace, '', 10, searchTerm)),
      map((response) => this.getReadableParentCompanies(response.crmObjects || [])),
      catchError((error) => {
        console.error(error);
        return of([]);
      }),
    );
  }

  getReadableParentCompanies = (parentCompanies: CrmObjectInterface[]): CompanyDisplayName[] =>
    parentCompanies.map(
      (company) =>
        ({
          ...company,
          displayName: this.crmFieldService.getFieldValueFromCrmObject(company, StandardIds.CompanyName)?.stringValue,
        } as CompanyDisplayName),
    );

  getMultiCompany(companyIds: string[]): Observable<CompanyDisplayName[]> {
    return this.crmObjectService.getMultiObject('Company', companyIds).pipe(
      map((response) => {
        if (!response || response?.crmObjects?.length === 0 || !response?.crmObjects?.[0].crmObjectId) {
          return {} as CompanyDisplayName[];
        }
        let crmObj: CrmObjectInterface[] = [];
        for (const crmObject of response.crmObjects) {
          crmObj = [...crmObj, crmObject];
        }
        return this.getReadableParentCompanies(crmObj);
      }),
    );
  }
}
